import React, { Fragment } from "react";
import Link from "next/link";
import styles from "./section_members.module.scss";
import TeamMemberCard from "../components/member";

const TeamMembersSection = ({ data, showBtn = true, customClasses }) => {
  return (
    <Fragment>
      {data && data?.length > 0 ? (
        <Fragment>
          {data?.map((item, i) => {
            return (
              <section
                key={i}
                className={customClasses?.root ? customClasses?.root : ""}
              >
                <div className="container">
                  <div className={styles.heading}>
                    <h3>{item?.categoryName}</h3>
                    {showBtn && (
                      <>
                        {item?.data?.length >= 12 && (
                          <Link
                            legacyBehavior
                            href={`/team/${item?.data[0]?.categorySlug}`}
                          >
                            <a className="btn btn-secondary btn-md">View All</a>
                          </Link>
                        )}
                      </>
                    )}
                  </div>
                  {item?.data?.length > 0 && (
                    <div className={styles.member_wrapper}>
                      {item?.data?.map((list, i) => {
                        return <TeamMemberCard data={list} key={list?.uuid} />;
                      })}
                    </div>
                  )}
                </div>
              </section>
            );
          })}
        </Fragment>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default TeamMembersSection;
